import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { BRAND, GRAY, ACCENT } from "../colors";

const REVIEW_TEXT = '"Best pizza in Brooklyn! The crust is perfect and the staff is so friendly."';
const REPLY_TEXT =
  "Hi Sarah! Thanks for choosing Joe's Pizza. We're thrilled you loved our famous Brooklyn-style crust! Our team takes pride in every pie. See you next time!";

export const AiReplyAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const reviewSlide = spring({ frame, fps, config: { damping: 15 } });
  const aiAppear = spring({ frame: frame - 35, fps, config: { damping: 12 } });
  const replyProgress = interpolate(frame, [50, 130], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const typedLength = Math.floor(replyProgress * REPLY_TEXT.length);
  const showCursor = frame > 50 && frame < 135;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: GRAY[50],
        padding: 48,
        justifyContent: "center",
        gap: 20,
      }}
    >
      {/* Review card */}
      <div
        style={{
          transform: `translateY(${interpolate(reviewSlide, [0, 1], [40, 0])}px)`,
          opacity: reviewSlide,
          backgroundColor: "white",
          borderRadius: 16,
          padding: "20px 28px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          border: `1px solid ${GRAY[200]}`,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              backgroundColor: BRAND[100],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 18,
              fontWeight: 700,
              color: BRAND[600],
            }}
          >
            SJ
          </div>
          <div>
            <div style={{ fontSize: 20, fontWeight: 600, color: GRAY[800] }}>Sarah J.</div>
            <div style={{ fontSize: 18, color: "#F59E0B", letterSpacing: 2 }}>★★★★★</div>
          </div>
        </div>
        <div style={{ fontSize: 19, color: GRAY[600], lineHeight: 1.5 }}>{REVIEW_TEXT}</div>
      </div>

      {/* AI generating indicator */}
      <div
        style={{
          transform: `scale(${aiAppear})`,
          opacity: aiAppear,
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "10px 20px",
          alignSelf: "center",
        }}
      >
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            background: `linear-gradient(135deg, ${BRAND[400]}, ${BRAND[600]})`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ fontSize: 16, color: "white" }}>✦</span>
        </div>
        <span style={{ fontSize: 18, fontWeight: 600, color: BRAND[600] }}>AI generating reply...</span>
      </div>

      {/* Reply card */}
      <div
        style={{
          opacity: interpolate(frame, [45, 55], [0, 1], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          }),
          backgroundColor: "white",
          borderRadius: 16,
          padding: "20px 28px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          border: `1px solid ${ACCENT[400]}`,
          borderLeftWidth: 4,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 10,
          }}
        >
          <span style={{ fontSize: 18, fontWeight: 600, color: ACCENT[600] }}>Suggested Reply</span>
          {frame > 130 && (
            <span style={{ fontSize: 18, color: ACCENT[500] }}>✓</span>
          )}
        </div>
        <div style={{ fontSize: 19, color: GRAY[700], lineHeight: 1.5 }}>
          {REPLY_TEXT.slice(0, typedLength)}
          {showCursor && (
            <span
              style={{
                display: "inline-block",
                width: 2,
                height: 20,
                backgroundColor: BRAND[500],
                marginLeft: 1,
                opacity: Math.sin(frame * 0.3) > 0 ? 1 : 0,
              }}
            />
          )}
        </div>
      </div>
    </AbsoluteFill>
  );
};
